import BaseService from "./BaseService";

class AffiliateService extends BaseService {
    constructor(baseUrl: string) {
        super(baseUrl)
    }

    getPromoterInfo = (companyId) => this.requests.get(`/${companyId}`)
}

const instance = new AffiliateService(BaseService.servicesConfig.AffiliateService)

export default instance